import { CheckBadgeIcon } from "@heroicons/react/24/outline"

export default function VerifiedCard({ verified }: { verified: boolean }) {
  return (
    verified && (
      <div className="flex !h-fit items-center gap-1 rounded-md bg-emerald-200 px-2 py-1 text-sm font-semibold text-emerald-600">
        <CheckBadgeIcon strokeWidth={2} className="h-6 w-6" />
        <span>Verified</span>
      </div>
    )
  )
}
